<template>
  <div class="not-found">
    <h2>Nie znaleziono strony pasującej do podanego adresu.</h2>
    <v-btn class="secondary mt-6" @click="$router.push('/strona-glowna')"
      >Wróć na stronę główną</v-btn
    >
  </div>
</template>

<script>
export default {
  name: "not-found"
};
</script>

<style lang="scss">
.not-found {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
